<template>
  <div class="d-flex align-center ga-2">
    <EmployeeAcknowledgementActionsSkeleton v-if="libraryLoading" />
    <template v-else>
      <v-btn
        variant="outlined"
        height="36"
        rounded="lg"
        class="download-btn"
        :loading="csvDownloadLoading"
        :disabled="libraryLoading || csvDownloadLoading"
        @click="downloadEmployeeAcknowledgementsCsv(route.query)"
      >
        <v-icon
          icon="$tray-arrow-down"
          class="mr-2"
          size="small"
        />
        Download CSV
      </v-btn>
      <v-btn
        color="brandPrimary"
        :disabled="!selectedCount || bulkReminderLoading"
        variant="flat"
        height="36"
        rounded="lg"
        :loading="bulkReminderLoading"
        @click="handlePrimaryAction"
      >
        {{ primaryButtonLabel }}
      </v-btn>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useEmployeeAcknowledgementsStore } from '@/stores/jobProfiles/employeeAcknowledgements';
import EmployeeAcknowledgementActionsSkeleton from './EmployeeAcknowledgementActionsSkeleton.vue';

const route = useRoute();

defineProps({
  libraryLoading: { type: Boolean, default: false },
  selectedCount: { type: Number, default: 0 },
});

const {
  selectedEmployeesForBulkCreate,
  bulkReminderLoading,
  csvDownloadLoading,
} = storeToRefs(useEmployeeAcknowledgementsStore());

const {
  openBulkCreateModal,
  openBulkSendReminderModal,
  downloadEmployeeAcknowledgementsCsv,
} = useEmployeeAcknowledgementsStore();

const allSelectedArePending = computed(() => {
  const employees = selectedEmployeesForBulkCreate.value;

  if (!employees?.length) return false;

  return employees.every((e) => e.acknowledgement_alert === 'pending_acknowledgement');
});

const primaryButtonLabel = computed(() => {
  const count = selectedEmployeesForBulkCreate.value?.length ?? 0;

  if (count === 0) return 'Create Acknowledgement';

  if (allSelectedArePending.value) {
    return count === 1 ? 'Send Reminder' : 'Send Reminders';
  }

  return count === 1 ? 'Create Acknowledgement' : 'Create Acknowledgements';
});

const handlePrimaryAction = () => {
  if (allSelectedArePending.value) {
    openBulkSendReminderModal();
  } else {
    openBulkCreateModal();
  }
};
</script>

<style lang="less" scoped>
.download-btn {
  border: 1px solid @stroke-default;
  color: @text-dark;
  background: @white;
}
</style>
